module.exports = __webpack_public_path__ + "img/live-play.7ddc45b3.png";